import React from 'react'
import PropTypes from 'prop-types'
import DivLayout from 'components/sales/divLayout/divLayout';
import localization from "assets/localization/localization";

const AddressView = ({
    details,
    addressType
}) => {
    return (
        <div className="panel-card">
            <div className="panel-heading">{addressType}</div>
            <div className="panel-body">
                <div className="details-listing">
                    <DivLayout
                        heading={localization.state}
                        data={details?.geo_state ? details.geo_state : localization.na}
                    />
                    <DivLayout
                        heading={localization.city}
                        data={details?.geo_city ? details.geo_city : localization.na}
                    />
                    <DivLayout
                        heading={localization.city}
                        data={details?.geo_city ? details.geo_city : localization.na}
                    />
                    <div className="details-list">
                        <strong className="data-title">{localization.address}</strong>
                        <span className="data-details">{details?.address_line_1 ? details.address_line_1 : localization.na} {details?.address_line_2}
                        </span>
                    </div>
                    <DivLayout
                        heading={localization.pinCode}
                        data={details?.geo_pin ? details.geo_pin : localization.na}
                    />
                </div>
            </div>
        </div>
    )
}

AddressView.propTypes = {

}

export default AddressView
